/* eslint-disable */

const path = 'https://upload.wikimedia.org/wikipedia/commons/7/7a/L-Phenylalanin_-_L-Phenylalanine.svg';

const svg = `
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Generator: Adobe Illustrator 12.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 51448)  -->
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://web.resource.org/cc/"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   version="1.1"
   id="Layer_1"
   width="231.759"
   height="128.034"
   viewBox="0 0 231.759 128.034"
   style="overflow:visible;enable-background:new 0 0 231.759 128.034;"
   xml:space="preserve"
   sodipodi:version="0.32"
   inkscape:version="0.45.1"
   sodipodi:docname="L-Phenylalanin.svg"
   inkscape:output_extension="org.inkscape.output.svg.inkscape"
   sodipodi:docbase="C:\"><metadata
   id="metadata58"><rdf:RDF><cc:Work
       rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
         rdf:resource="http://purl.org/dc/dcmitype/StillImage" /></cc:Work></rdf:RDF></metadata><defs
   id="defs56" /><sodipodi:namedview
   inkscape:window-height="579"
   inkscape:window-width="801"
   inkscape:pageshadow="2"
   inkscape:pageopacity="0.0"
   guidetolerance="10.0"
   gridtolerance="10.0"
   objecttolerance="10.0"
   borderopacity="1.0"
   bordercolor="#666666"
   pagecolor="#ffffff"
   id="base"
   inkscape:zoom="2.9523409"
   inkscape:cx="115.8795"
   inkscape:cy="64.016998"
   inkscape:window-x="198"
   inkscape:window-y="198"
   inkscape:current-layer="Layer_1" />
<path
   d="M 104.54648,49.4516 L 104.54648,47.59815 L 137.22743,66.40815 L 137.22743,67.35815 L 136.37148,67.78565 L 104.54648,49.4516 z "
   id="polygon3" />
<path
   d="M 138.08148,67.78565 L 137.22743,67.35815 L 137.22743,66.40815 L 169.85898,47.59815 L 169.85898,49.4516 L 138.08148,67.78565 z "
   id="polygon5" />
<g
   id="g7"
   transform="matrix(0.95,0,0,0.95,5.793975,3.20085)">
	<path
   d="M 198.856,68.619 C 198.856,65.766 199.622,63.534 201.154,61.921 C 202.686,60.307 204.664,59.5 207.087,59.5 C 208.674,59.5 210.104,59.879 211.378,60.637 C 212.652,61.396 213.623,62.452 214.291,63.808 C 214.96,65.163 215.294,66.702 215.294,68.42 C 215.294,70.163 214.942,71.722 214.238,73.097 C 213.535,74.472 212.539,75.514 211.249,76.221 C 209.959,76.928 208.568,77.282 207.075,77.282 C 205.457,77.282 204.011,76.891 202.737,76.11 C 201.463,75.329 200.498,74.261 199.841,72.91 C 199.185,71.558 198.856,70.128 198.856,68.619 z M 201.2,68.648 C 201.2,70.718 201.757,72.349 202.871,73.541 C 203.985,74.733 205.383,75.328 207.063,75.328 C 208.775,75.328 210.184,74.726 211.291,73.523 C 212.396,72.32 212.95,70.613 212.95,68.402 C 212.95,67.004 212.714,65.783 212.24,64.74 C 211.767,63.697 211.076,62.888 210.165,62.314 C 209.254,61.74 208.232,61.453 207.099,61.453 C 205.489,61.453 204.103,62.006 202.942,63.111 C 201.781,64.216 201.2,66.063 201.2,68.648 z "
   id="path9" />
	<path
   d="M 218.306,76.984 L 218.306,59.797 L 220.587,59.797 L 220.587,66.86 L 229.478,66.86 L 229.478,59.797 L 231.759,59.797 L 231.759,76.985 L 229.478,76.985 L 229.478,68.891 L 220.587,68.891 L 220.587,76.985 L 218.306,76.985 L 218.306,76.984 z "
   id="path11" />
</g>
<path
   d="M 169.85898,49.4516 L 169.85898,47.59815 L 194.32147,61.70565 L 193.51493,63.13065 L 169.85898,49.4516 z "
   id="polygon13" />
<g
   id="g15"
   transform="matrix(0.95,0,0,0.95,5.793975,3.20085)">
	<path
   d="M 164.457,9.119 C 164.457,6.266 165.223,4.034 166.754,2.421 C 168.287,0.807 170.264,0 172.688,0 C 174.274,0 175.705,0.379 176.979,1.137 C 178.252,1.896 179.223,2.952 179.892,4.308 C 180.561,5.664 180.895,7.202 180.895,8.92 C 180.895,10.663 180.543,12.222 179.839,13.597 C 179.135,14.972 178.139,16.014 176.85,16.721 C 175.559,17.428 174.168,17.782 172.676,17.782 C 171.057,17.782 169.612,17.391 168.338,16.61 C 167.063,15.829 166.098,14.761 165.442,13.41 C 164.786,12.059 164.457,10.628 164.457,9.119 z M 166.801,9.148 C 166.801,11.218 167.358,12.849 168.471,14.041 C 169.586,15.232 170.983,15.828 172.664,15.828 C 174.375,15.828 175.785,15.226 176.891,14.023 C 177.997,12.82 178.551,11.113 178.551,8.902 C 178.551,7.504 178.315,6.283 177.841,5.24 C 177.367,4.197 176.676,3.388 175.766,2.814 C 174.855,2.24 173.832,1.953 172.7,1.953 C 171.089,1.953 169.704,2.506 168.542,3.611 C 167.381,4.717 166.801,6.563 166.801,9.148 z "
   id="path17" />
</g>
<path
   d="M 166.20243,22.23315 L 167.81743,22.23315 L 167.81743,50.16315 L 166.20243,50.16315 L 166.20243,22.23315 z "
   id="rect19" />
<path
   d="M 171.90243,22.23315 L 173.51743,22.23315 L 173.51743,50.16315 L 171.90243,50.16315 L 171.90243,22.23315 z "
   id="rect21" />
<g
   id="g23"
   transform="matrix(0.95,0,0,0.95,5.793975,3.20085)">
	<path
   d="M 131.528,116.685 L 131.528,99.497 L 133.868,99.497 L 142.872,112.986 L 142.872,99.497 L 145.06,99.497 L 145.06,116.685 L 142.72,116.685 L 133.716,103.196 L 133.716,116.685 L 131.528,116.685 z "
   id="path25" />
	<path
   d="M 148.97,116.685 L 148.97,99.497 L 151.251,99.497 L 151.251,106.56 L 160.142,106.56 L 160.142,99.497 L 162.423,99.497 L 162.423,116.685 L 160.142,116.685 L 160.142,108.591 L 151.251,108.591 L 151.251,116.685 L 148.97,116.685 z "
   id="path27" />
</g>
<g
   id="g29"
   transform="matrix(0.95,0,0,0.95,5.793975,3.20085)">
	<path
   d="M 173.205,119.669 L 173.205,121.185 L 164.674,121.185 C 164.662,120.804 164.723,120.438 164.86,120.086 C 165.078,119.506 165.426,118.935 165.908,118.373 C 166.388,117.811 167.079,117.162 167.977,116.426 C 169.373,115.273 170.32,114.362 170.817,113.692 C 171.315,113.022 171.565,112.387 171.565,111.789 C 171.565,111.163 171.339,110.636 170.889,110.205 C 170.439,109.775 169.852,109.56 169.129,109.56 C 168.363,109.56 167.752,109.789 167.293,110.248 C 166.834,110.707 166.602,111.342 166.596,112.153 L 164.971,111.981 C 165.082,110.765 165.502,109.839 166.231,109.203 C 166.959,108.565 167.936,108.247 169.165,108.247 C 170.403,108.247 171.384,108.59 172.106,109.276 C 172.829,109.962 173.19,110.812 173.19,111.826 C 173.19,112.342 173.084,112.849 172.872,113.347 C 172.661,113.845 172.309,114.37 171.819,114.921 C 171.329,115.472 170.515,116.228 169.38,117.189 C 168.429,117.987 167.817,118.527 167.546,118.812 C 167.275,119.095 167.05,119.381 166.874,119.668 L 173.205,119.668 L 173.205,119.669 z "
   id="path31" />
</g>
<path
   d="M 140.83648,95.5266 L 133.56898,95.5266 L 136.37148,67.78565 L 137.22743,67.35815 L 138.08148,67.78565 L 140.83648,95.5266 z "
   id="polygon33" />
<path
   d="M 72.721475,67.83315 L 71.914925,67.35815 L 71.914925,66.40815 L 104.54648,47.59815 L 104.54648,49.4516 L 72.721475,67.83315 z "
   id="polygon35" />
<path
   d="M 39.281475,49.4516 L 39.281475,47.59815 L 71.914925,66.40815 L 71.914925,67.35815 L 71.106475,67.83315 L 39.281475,49.4516 z "
   id="polygon37" />
<path
   d="M 38.854925,55.72065 L 39.661475,54.3441 L 66.642425,69.92315 L 65.833975,71.34815 L 38.854925,55.72065 z "
   id="polygon39" />
<path
   d="M 7.408975,67.83315 L 5.793975,66.88315 L 39.281475,47.59815 L 39.281475,49.4516 L 7.408975,67.83315 z "
   id="polygon41" />
<path
   d="M 7.408975,104.59815 L 5.793975,105.54815 L 5.793975,66.88315 L 7.408975,67.83315 L 7.408975,104.59815 z "
   id="polygon43" />
<path
   d="M 11.446475,70.635651 L 13.061475,70.635651 L 13.061475,101.79565 L 11.446475,101.79565 L 11.446475,70.635651 z "
   id="rect45" />
<path
   d="M 39.281475,122.98065 L 39.281475,124.83315 L 5.793975,105.54815 L 7.408975,104.59815 L 39.281475,122.98065 z "
   id="polygon47" />
<path
   d="M 71.106475,104.59815 L 72.721475,105.54815 L 39.281475,124.83315 L 39.281475,122.98065 L 71.106475,104.59815 z "
   id="polygon49" />
<path
   d="M 65.833975,101.08315 L 66.642425,102.50815 L 39.661475,118.0891 L 38.854925,116.6641 L 65.833975,101.08315 z "
   id="polygon51" />
<path
   d="M 71.106475,67.83315 L 71.914925,67.35815 L 72.721475,67.83315 L 72.721475,105.54815 L 71.106475,104.59815 L 71.106475,67.83315 z "
   id="polygon53" />
</svg>
`;

const Phenylalanin = { path, svg };

export default Phenylalanin;
